export default {
    to: "/dashboard/waas/",
    order: 3,
    icon: "mdi-bag-personal-outline",
    title: "Merchant",
    disabled: false,
    value: 0,
    sublinks: [
        {
            to: "/dashboard/waas/merchant/beneficiaries",
            order: 3,
            icon: "mdi-account-group",
            title: "Beneficiaries",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/merchant/send-to-beneficiary",
            order: 3,
            icon: "mdi-send-circle",
            title: "Send To Beneficiary",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/merchant/query-account-balance",
            order: 3,
            icon: "mdi-jquery",
            title: "Query Account Balance",
            disabled: false,
            value: 0,
        },
    ]
}
